import { Component, OnInit, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-blog-landing-tables',
  imports: [CommonModule, RouterLink],
  templateUrl: './blog-landing-tables.component.html',
  styleUrl: './blog-landing-tables.component.scss'
})
export class BlogLandingTablesComponent implements OnInit {

  private http = inject(HttpClient);

  message = 'Loading...';
  blogs: any;
  tables: any;

  ngOnInit() {

    // Get Blog Posts
    this.http.get<{ results: any[] }>('/api/tables').subscribe({
      next: (res) => {
        this.tables = res.results.map(post => ({
          ...post,
          blogDescription: this.stripHtmlAndTruncate(post?.values?.blog_description, 100)
        }));
      },
      error: (err) => {
        this.tables = [];
      }
    });


  }

  formatJson(data: any): string {
    return JSON.stringify(data, null, 2);
  }

  stripHtmlAndTruncate(html: string, limit: number = 100): string {
    const text = html
      .replace(/<[^>]+>/g, '')         // remove HTML tags
      .replace(/\s+/g, ' ')            // collapse all whitespace/newlines to single space
      .trim();                         // remove leading/trailing spaces

    return text.length > limit ? text.substring(0, limit) + '...' : text;
  }



}
